import React, {useEffect, useState} from 'react'
import axios from "axios";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {COUNTRIES} from "../Api/Contants";


const useStyles = makeStyles((theme) => ({
    formControl: {
      marginRight: theme.spacing(3),
    
      minWidth: 'auto',
    
    },
    select:{
        
        minWidth: theme.spacing(7)
    },
    
  }));

const WhatsappSelect = (props) => {
    const {values, handleChange} = props
    const [paises, setPaises] = useState({})
    const [loading, setLoading] = useState(true)
    useEffect(() => {

        setPaises(COUNTRIES);
        setLoading(false);


    }, [])
    const classes = useStyles();
    return (
        <>
            <FormControl className={classes.formControl} fullWidth={!!props.fullWidth} required>


                <InputLabel
                    id='country-label'
                >
                    País
                </InputLabel>
                <Select
                    required
                    labelId='country-label'
                    classes={{ select: (classes.select) }}
                    value={values.countryId ? values.countryId : values.country.id}
                    id={props.menu ? 'country' : 'countryId'}
                    name={props.menu ? 'country' : 'countryId'}
                    onChange={handleChange}
                >
                    
                    {
                        (!loading) &&
                        paises.map(pais => {
                            return (
                                <MenuItem key={pais.id} value={props.menu ? `${pais.nombre}(+${pais.phone_code})` : pais.id}>
                                    {pais.nombre}(+{pais.phone_code})
                                </MenuItem>

                            )
                        })
                    }
                </Select>
            </FormControl>
        </>
    )
}

export default WhatsappSelect
